<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Psicologica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPsicologica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPsicologica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiPsicologica.id" @click="onSaveAnamnesiPsicologica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPsicologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPsicologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPsicologica: "/rsaschedarelazionesanitariaanamnesipsicologica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPsicologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsicologica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsicologicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsicologicaError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsicologicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPsicologica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsicologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPsicologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiPsicologica() {
            let me = this;
            me.jsonDataAnamnesiPsicologica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPsicologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsicologica, me.jsonDataAnamnesiPsicologica, me.saveSchedaRelazioneSanitariaAnamnesiPsicologicaSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiPsicologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPsicologicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi psicologica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiPsicologicaErrorResponse() {
            console.error("Errore nel salvataggio anamnesi psicologica:");
        },
    },
};
</script>
